angular.module('zc.projects')

.directive 'zcCampaignRange', ->
  restrict: 'E'
  scope:
    campaign: '='
    dateOnly: '='
  templateUrl: '/templates/projects.campaigns/views/directives/campaign_range.html'
  link: (scope, element, attrs) ->



// WEBPACK FOOTER //
// ./src/zenclerk_modules/projects.campaigns/directives/campaign_range.coffee